import(/* webpackMode: "eager" */ "/app/packages/risk-dashboard/src/global/layout-client/layout-client.tsx");
import(/* webpackMode: "eager" */ "/app/packages/ui/styles/fonts.css");
import(/* webpackMode: "eager" */ "/app/packages/ui/styles/theme.css");
import(/* webpackMode: "eager" */ "/app/packages/ui/styles/reset.css")